import {CookiesProvider} from 'react-cookie';
import {Outlet} from 'react-router-dom';
import {BookingProvider} from 'src/context/BookingContext';
import {BookingSessionProvider} from 'src/context/BookingSessionContext';
import {ClinicDetailsProvider} from 'src/context/ClinicDetailsContext';
import {LocationDetailsProvider} from 'src/context/LocationDetailsContext';
import {useClearTrackingCookies} from 'src/hooks/useClearTrackingCookies';
import {useCssWorkarounds} from 'src/hooks/useCssWorkarounds';

export function LocationRoot() {
    useCssWorkarounds();
    useClearTrackingCookies();

    return (
        <CookiesProvider>
            <LocationDetailsProvider>
                <BookingProvider>
                    <ClinicDetailsProvider>
                        <BookingSessionProvider>
                            <Outlet />
                        </BookingSessionProvider>
                    </ClinicDetailsProvider>
                </BookingProvider>
            </LocationDetailsProvider>
        </CookiesProvider>
    );
}
